import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GeneralService } from '../../../shared/services/general.service';
import { EfficiencyDetails } from '../../../shared/constants';

@Component({
  selector: 'app-efficiency-tab',
  templateUrl: './efficiency-tab.component.html',
  styleUrls: ['./efficiency-tab.component.scss']
})
export class EfficiencyTabComponent implements OnInit {
  EfficiencyDetails = EfficiencyDetails;
  tab: string;
  @Input() defaultTab: string;
  @Output()
  change: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(private route: ActivatedRoute,
              private generalService: GeneralService) { }

  ngOnInit() {
    this.tab = this.defaultTab;
    this.route.queryParams.subscribe(values => {
      if (Object.keys(EfficiencyDetails).map(k => k.split('_').join(' ')).includes(values.efficiencyType)) {
        this.tab = values.efficiencyType;
        this.change.emit(values.efficiencyType !== undefined);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/efficiency/efficiency-tab/efficiency-tab.component.ts